import { Injectable } from "@angular/core";
import { ApiService } from "@meddatacore/common";
import { Observable } from "rxjs";
import { DataSourceResponse } from "../../models";
import { InfectiousPatientContactType } from "../../models/manuals/infectious-patient-contact-type";
import { HttpParamsEncoder } from "../../tools";

@Injectable({ providedIn: 'root' })
export class InfectiousPatientContactTypeService extends ApiService {
  endPoint = '/api/InfectiousPatientContacts';
  create(model: InfectiousPatientContactType) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: InfectiousPatientContactType) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  get(id: string): Observable<InfectiousPatientContactType> {
    return this.http.get<InfectiousPatientContactType>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  getList(queryParams: any): Observable<DataSourceResponse<InfectiousPatientContactType>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}